// src/App.js
import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

// ------------------- Common Components -------------------
import Navbar from "./component/Common/Navbar";

// ------------------- Main Pages -------------------
import HomePageComponent from "./component/homepage/homepage.component";
import PricePageComponent from "./component/pricepage/pricepage.component";
import AuthFormComponent from "./component/authform/authform.component";
import ForgotPasswordComponent from "./component/authform/forgotpassword.component";
import DashboardComponent from "./component/dashboard/dashboard.component";
import ContactUsComponent from "./component/ContactUs/ContactUsPage.component";
import SeoResultDashboard from "./component/SeoResultDashboard/SeoResultDashboard";

// ------------------- Dynamic Product Page -------------------
import ProductPageComponent from "./component/ProductPageComponent/ProductPageComponent";

// ------------------- Checkout Flow -------------------
import Checkout from "./component/Checkout/Checkout";
import PaymentPage from "./component/PaymentPage/PaymentPage";

// --------------------Profile Page---------------------
import ProfilePage from "./component/ProfilePage/ProfilePage";

// ------------------- Finance Layout -------------------
import FinanceLayout from "./Calculators/CommonComponents/FinanceLayout";

const AppContent = () => {
  const location = useLocation();
  
  const noNavbarRoutes = ['/login', '/forgot-password'];
  const shouldHideNavbar = noNavbarRoutes.includes(location.pathname);

  return (
    <>
      {!shouldHideNavbar && <Navbar />}

      <Routes>
        {/* ----------- Main Routes ----------- */}
        <Route path="/" element={<HomePageComponent />} />
        <Route path="/pricing" element={<PricePageComponent />} />
        <Route path="/login" element={<AuthFormComponent />} />
        <Route path="/forgot-password" element={<ForgotPasswordComponent />} />
        <Route path="/dashboard" element={<DashboardComponent />} />
        <Route path="/contact" element={<ContactUsComponent />} />
        <Route path="/seo-results" element={<SeoResultDashboard />} />

        {/* ----------- Dynamic Product Route ----------- */}
        <Route path="/product/:productId" element={<ProductPageComponent />} />

        {/* ----------- Checkout Flow Routes ----------- */}
        <Route path="/payment/checkout" element={<Checkout />} />
        <Route path="/payment" element={<PaymentPage />} />

        {/* ----------- Profile Page ----------- */}
        <Route path="/profile" element={<ProfilePage />} />


        {/* ----------- Finance Section ----------- */}
        <Route path="/finance/*" element={<FinanceLayout />} />
      </Routes>
    </>
  );
};

const App = () => {
  return <AppContent />;
};

export default App;